<template>
  <div></div>
</template>

<script>
// 该页面用来处理微信登录逻辑
export default {
    data(){
        return{
            code:'',//微信授权code
            redirect:''//绑定成功后的重定向地址
        }
    },
    mounted(){
        this.getcode();
        this.getDirect();
    },
    methods: {
        getDirect() {//获取重定向地址
        let redirect = this.common.GetParam(location.href, "redirect"); //重定向链接(该页面通过qq页面重定向过来，只能在这里存入)
        console.log("redirect=======" + redirect);
        if (redirect.indexOf("#") > -1) {
            redirect = redirect.split("#")[0];
        }
        console.log("redirect=======" + redirect);
        sessionStorage.setItem("redirect", redirect);
        },
        getcode(){//获取code
            let code = this.common.GetParam(location.href, "code"); //重定向链接(该页面通过qq页面重定向过来，只能在这里存入)
            this.code = code;
            if(code){
              this.bindWX();
            }else{
              const wxUrl = 'https://open.weixin.qq.com/connect/qrconnect?appid=wx2977c4750e66faf6&response_type=code&scope=snsapi_login&state=hzw&redirect_uri='
              let _url = wxUrl + encodeURIComponent("http://www.sctcc.cn/index.html#/personal_center/account_settings/WX_bindingLogin??redirect=" + this.redirect);
              window.location.href = _url;
            }

        },
        /***
         *  绑定微信
         * */
        bindWX() {
          let params = {
            code:this.code
          };
          this.postAxios(api.bindOpenUserWeChat, params, true).then(res => {
            console.log(res);
            console.log("绑定微信成功");
            if (res.error.err_code === 0) {
              this.$router.push({ path: "/personal_center/account_settings/WX_binding?success=true" });
            }else if(res.error.err_code === 2){ //该微信账号已绑定过
              this.$message.error(res.error.err_msg);
              this.$router.push({ path: "/personal_center/account_settings/WX_binding" });
            }
          });
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
